<template>
  <div class="benchmark-select">
    <label :for="selectId">{{ label }}</label>
    <select v-model="selectedBenchmark" :id="selectId">
      <option value="">+ Add Benchmark</option>
      <option
        v-for="benchmark in benchmarks"
        :key="benchmark.notation"
        :value="benchmark.notation"
        :style="{ color: benchmark.color }"
      >
        {{ benchmark.label }}
      </option>
    </select>
  </div>
</template>

<script>
import { defaultBenchmarks } from "../util/chart/defaultBenchmarks";
import { eventBus } from "../util/instances";

const getBenchmarks = () => defaultBenchmarks;

export default {
  name: "chart-control-benchmark",
  props: {
    channel: {
      type: String,
      required: false,
      default: "1"
    },
    config: {
      type: Object,
      required: false,
      default: () => {}
    },
    benchmarks: {
      type: Array,
      required: false,
      default: getBenchmarks
    },
    label: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      selectedBenchmark: ""
    };
  },
  watch: {
    selectedBenchmark: function() {
      const benchmark = this.benchmarks.find(
        benchmark => benchmark.notation === this.selectedBenchmark
      );
      eventBus.$emit(`${this.channel}:changeBenchmark`, benchmark);
    }
  },
  computed: {
    selectId: function() {
      return "benchmark-select-" + this.channel;
    }
  }
};
</script>

<style scoped>
.benchmark-select {
  color: #000;
}
</style>
